// React and Next.js core imports
import { FC } from "react";

// shadcn components
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface UpdatePromptProps {
  onUpdate: () => void;
  onPostpone: () => void;
  open?: boolean;
}

export const UpdatePrompt: FC<UpdatePromptProps> = ({
  onUpdate,
  onPostpone,
  open = false,
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onPostpone()}>
      <DialogContent
        className="sm:max-w-[425px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle>New Update Available</DialogTitle>
          <DialogDescription>
            A new version of the application is available. Update now to get the
            latest features and improvements.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:justify-start">
          <Button variant="default" onClick={onUpdate}>
            Update Now
          </Button>
          <Button variant="outline" onClick={onPostpone}>
            Later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
